import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const useDrawer = () => {
  const router = useRouter()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])
  const drawerOpen = name => {
    history.scrollRestoration = 'auto'
    router.push(router.asPath, `${router.asPath.split('#')[0]}#${name}`, {
      scroll: true,
    })
  }

  const drawerClose = () => {
    const isDirectEntry = !sessionStorage.getItem('previous_page')
    if (isDirectEntry) {
      router.replace(router.asPath.split('#')[0])
    } else {
      router.back()
    }
    history.scrollRestoration = 'manual'
  }

  const isDrawerOpen = name => {
    if (!isMounted) return false
    return router.asPath?.split('#')[1]?.includes(name)
  }

  return {
    drawerOpen,
    drawerClose,
    isDrawerOpen,
  }
}

export default useDrawer
